/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
    path : '/active',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/AccountActive.jsx').default)
        }, 'active')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/active.js